<!--
 * @Descripttion: 
 * @version: 0.1.0
 * @Author: wangcan
 * @Date: 2023-02-15 16:52:51
 * @LastEditors: wangcan
 * @LastEditTime: 2023-06-28 21:55:26
-->
<template>
  <div class="companyDetail">
    <van-nav-bar left-arrow @click-left="goBack" title="岗位详情" />

    <div class="wrap-bg">
      <div class="positionBox">
        <ul>
          <li>
            <h4>
              {{ positionInfo.name
              }}<span>{{ positionInfo.formalSalary }}</span>
            </h4>
            <div class="info">
              <span>{{
                positionInfo.address ? positionInfo.address : "-"
              }}</span>
              |
              <span>招聘{{ positionInfo.recruitNum }}人</span>
            </div>
            <div class="line"></div>
            <div class="infos">
              <p>岗位职责：</p>
              <div
                v-html="
                  positionInfo.jobResponsibilities
                    ? positionInfo.jobResponsibilities
                    : '-'
                "
              ></div>

              <p>岗位要求：</p>
              <div
                v-html="
                  positionInfo.jobRequirements
                    ? positionInfo.jobRequirements
                    : '-'
                "
              ></div>
            </div>
            <p class="col-wrap">
              到岗时间：<em>{{
                positionInfo.toJobTime ? positionInfo.toJobTime : "-"
              }}</em>
            </p>

            <p class="col-wrap">
              试用期薪资：<em>{{
                positionInfo.internshipSalary
                  ? positionInfo.internshipSalary
                  : "-"
              }}</em>
            </p>
            <p class="col-wrap">
              转正薪资：<em>{{
                positionInfo.formalSalary ? positionInfo.formalSalary : "-"
              }}</em>
            </p>
            <p class="col-wrap">
              保险：<em>{{
                positionInfo.insurance ? positionInfo.insurance : "-"
              }}</em>
            </p>
            <p class="col-wrap">
              职位发展：<em>{{
                positionInfo.postDevelopment
                  ? positionInfo.postDevelopment
                  : "-"
              }}</em>
            </p>
            <p class="col-wrap">
              其他：<em>{{ positionInfo.other ? positionInfo.other : "-" }}</em>
            </p>
            <!-- <el-button
              class="send-resume"
              type="primary"
              @click="sendResumeMobile(v.meetingPostId)"
              >投递简历</el-button
            > -->
          </li>
        </ul>
      </div>

      <div class="but-wrap">
        <van-button
          class="cancle"
          round
          block
          type="info"
          @click="sendResumeMobile(positionInfo.meetingPostId)"
          >投递简历</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      positionInfo: {},
    };
  },
  // components: { SendAdd },
  mounted() {
    console.log(this.$route.query.item);
    this.positionInfo = JSON.parse(this.$route.query.item);
    // this.positionList=this.$route.query.v;
    // this.meetingCompanyId = this.$route.query.meetingCompanyId;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    /**
     * @name: 投递简历-手机端
     * @param {*} id
     */

    sendResumeMobile(id) {
      this.$router.push({
        name: "sendAddMobile",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
$--color-primary: #266eff;
.wrap-bg {
  padding-bottom: 1.9rem;
}
.positionBox {
  width: 100%;
  font-size: 0.36rem;
  line-height: 0.7rem;
  color: #646566;
  .line {
    width: 100%;
    height: 1px;
    background: #dcdfe6;
  }
  ul {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    // @include display-flex(flex-start);
    flex-wrap: wrap;
    padding: 0;
    // margin: 0 .2rem;
    li {
      // width: calc(100% - .8rem);
      box-sizing: border-box;
      padding: 0.4rem;
      border-radius: 0.05rem;
      overflow: hidden;
      position: relative;
      background: #fff;
      width: 100%;
      // &:nth-child(4n) {
      //   margin-right: 0px;
      // }
      h4 {
        color: $--color-primary;
        font-weight: normal;
        margin: 0 0 0.2rem;
        position: relative;
        font-size: 0.42rem;

        span {
          position: absolute;
          top: 0;
          right: 0;
          color: #ff3326;
        }
      }

      .info {
        margin-bottom: 0.1rem;
        color: #999;
        font-size: 0.32rem;
      }

      .infos {
        font-size: 0.36rem;
        line-height: 0.6rem;
        width: 100%;
        //   @include text-overflow;
        margin: 0.2rem 0;
        p {
          margin: 0.4rem 0 0.1rem;
          font-size: 0.38rem;
          color: #333;
        }
        div {
          line-height: 0.7rem;
          color: #646566;
        }
      }
    }
  }
  .col-wrap {
    em {
      color: #333;
    }
  }
}
.but-wrap {
  width: calc(100% - 0.6rem);
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0.3rem;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.1);
}
</style>
